import type {
    RepeatableLegacyAggregateSerialization,
    RepeatableLegacyAggregateTargetInput,
    RepeatableLegacySlotSerialization,
    RepeatableLegacySlotTargetInput,
} from '../../interfaces/input.interface';

const DEFAULT_REPEATABLE_SEPARATOR = ';';

export interface ReactiveRepeatableLegacyAggregateSerializationConfig {
    readonly targets?: Record<string, RepeatableLegacyAggregateTargetInput | RepeatableLegacyAggregateTargetInput[]>;
    readonly separator?: string;
    readonly trimTrailingEmptyRows?: boolean;
    readonly trimTrailingEmptyRowsBy?: string | readonly string[];
}

export interface ReactiveRepeatableLegacySlotSerializationConfig {
    readonly targets: Record<string, RepeatableLegacySlotTargetInput | RepeatableLegacySlotTargetInput[]>;
    readonly rows?: number;
    readonly removeBindingFields?: boolean;
}

export interface ReactiveRepeatableTrimTrailingRowsConfig {
    readonly targets?: Record<string, RepeatableLegacyAggregateTargetInput | RepeatableLegacyAggregateTargetInput[]>;
    readonly separator?: string;
    readonly trimTrailingEmptyRowsBy?: string | readonly string[];
}

/** Builds legacy serialization configuration without leaking undefined optional values. */
export class ReactiveRepeatableLegacySerializationFactory {
    public static aggregate(config: ReactiveRepeatableLegacyAggregateSerializationConfig): RepeatableLegacyAggregateSerialization {
        return {
            ...(config.targets !== undefined ? { targets: config.targets } : {}),
            ...(config.separator !== undefined ? { separator: config.separator } : {}),
            ...(config.trimTrailingEmptyRows !== undefined ? {
                trimTrailingEmptyRows: config.trimTrailingEmptyRows,
            } : {}),
            ...(config.trimTrailingEmptyRowsBy !== undefined ? {
                trimTrailingEmptyRowsBy: config.trimTrailingEmptyRowsBy,
            } : {}),
        };
    }

    public static trimTrailingRows(
        config: ReactiveRepeatableTrimTrailingRowsConfig = {},
    ): RepeatableLegacyAggregateSerialization {
        return this.aggregate({
            ...(config.targets !== undefined ? { targets: config.targets } : {}),
            separator: config.separator ?? DEFAULT_REPEATABLE_SEPARATOR,
            trimTrailingEmptyRows: true,
            ...(config.trimTrailingEmptyRowsBy !== undefined ? {
                trimTrailingEmptyRowsBy: config.trimTrailingEmptyRowsBy,
            } : {}),
        });
    }

    public static slots(config: ReactiveRepeatableLegacySlotSerializationConfig): RepeatableLegacySlotSerialization {
        return {
            targets: config.targets,
            ...(config.rows !== undefined ? { rows: config.rows } : {}),
            ...(config.removeBindingFields !== undefined ? { removeBindingFields: config.removeBindingFields } : {}),
        };
    }
}
